import "./TestReportTypeViewEditComponent.scss";
import {useCallback, useEffect, useState} from "react";
import TestReportTypeViewComponent from "./test-report-type-view/TestReportTypeViewComponent";
import TestReportTypeEditComponent from "./test-report-type-edit/TestReportTypeEditComponent";

interface TestReportTypeViewEditComponentProps {
    testDetails: any
    onUpdateInformation: Function;
    onModeChange: Function;
    canEdit: boolean;
}

const TestReportTypeViewEditComponent = (props: TestReportTypeViewEditComponentProps) => {
    const {testDetails, onUpdateInformation, onModeChange, canEdit} = props;
    const [mode, setMode] = useState<"view" | "edit">("view");
    const [testReportTypeInformation, setTestReportTypeInformation] = useState<any>(undefined);

    const handleTestInformationUpdate = useCallback((updatedTestInformation: any) => {
        onUpdateInformation(updatedTestInformation);
        setMode("view");
    }, [onUpdateInformation]);

    const handlePanelInformationEditCancel = useCallback(() => {
        setMode("view");
    }, []);

    useEffect(() => {
        if (testDetails) {
            setTestReportTypeInformation(testDetails);
        }
    }, [testDetails]);

    useEffect(() => {
        onModeChange(mode)
    }, [mode, onModeChange])
    return (
        <div className={'test-report-type-view-edit-component details-tab-data-wrapper'}>
            {
                mode === "view" && (
                    <TestReportTypeViewComponent
                        testDetails={testReportTypeInformation}
                        onEditModeOpen={() => {
                            setMode("edit")
                        }}
                        canEdit={canEdit}
                    />
                )
            }
            {
                mode === "edit" && (
                    <TestReportTypeEditComponent
                        testDetails={testReportTypeInformation}
                        onUpdateComplete={handleTestInformationUpdate}
                        onEditCancel={handlePanelInformationEditCancel}
                    />
                )
            }
        </div>
    );

};

export default TestReportTypeViewEditComponent;
